import { defineStore } from 'pinia'
import Network from '@/Network'
import { CreateSchedule } from '@/Network/Types/Requests/ScheduleRequests'
import { BasicCompany } from '@/Network/Types/Responses/CompanyResponses'

export type CompanyState = {
  myCompanies: BasicCompany[]
  listCompanies: { title: string; value: string }[]
  companyIdsSelected: Set<number>
}

export const useCompanyStore = defineStore('company', {
  state: (): CompanyState => ({
    myCompanies: [],
    listCompanies: [],
    companyIdsSelected: new Set<number>()
  }),
  actions: {
    async getMyCompanies(): Promise<void> {
      try {
        const response = await Network.company.listBasic()

        this.myCompanies = response

        this.listCompanies = this.myCompanies.map((c) => ({ title: c.name, value: String(c.id) }))
        const listCompaniesIds: number[] = this.myCompanies.map((c) => c.id)
        Network.company.persistLocalCompanyList(listCompaniesIds)
      } catch (error) {
        console.error('Erro ao obter empresas:', error)
        this.myCompanies = []
        this.listCompanies = []
        this.companyIdsSelected.clear()
      }
    },
    setCompanyIdsSelected({ id, checked }: { id: number; checked: boolean }) {
      if (checked) this.companyIdsSelected.add(id)
      else this.companyIdsSelected.delete(id)
      Network.company.persistLocalCompanyList(Array.from(this.companyIdsSelected))
    },
    async create({ healthUnitId, payload }: { healthUnitId: number; payload: CreateSchedule }) {
      await Network.schedule.create(healthUnitId, payload)
    },
    async remove(scheduleId: number): Promise<void> {
      await Network.schedule.remove(scheduleId)
    }
  }
})
